import { useNavigate, useSearchParams } from 'react-router'
import { ArrowLeft } from 'lucide-react'
import './HomeBackButton.css'

/**
 * Shows a "Back to Dashboard" control on list pages that were opened from a
 * Home dashboard KPI card (links carry `?from=home`). Navigating back returns
 * to the exact dashboard tab the user came from via browser history.
 */
export function HomeBackButton() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  if (searchParams.get('from') !== 'home') return null

  const handleBack = () => {
    const historyIdx =
      typeof window !== 'undefined' &&
      window.history.state &&
      typeof window.history.state.idx === 'number'
        ? window.history.state.idx
        : 0
    // Prefer history so we land on the precise dashboard tab; fall back to Home.
    if (historyIdx > 0) navigate(-1)
    else navigate('/')
  }

  return (
    <div className="home-back-bar">
      <button type="button" className="home-back-btn" onClick={handleBack}>
        <ArrowLeft size={15} />
        <span>Back to Dashboard</span>
      </button>
    </div>
  )
}

export default HomeBackButton
